import { GetStaticProps } from 'next';
// import SwaggerUI from 'swagger-ui-react';
import { GetStaticPropsContext } from 'next/types';
import { serverSideTranslations } from '@utils/i18n/serverSideTranslations';
import { TLocale } from '@typescript/index';
import { getLayoutData } from '@features/layout/api';

import 'swagger-ui-react/swagger-ui.css';

// type PropsType = {
//   spec: ISwaggerSpec;
// };

// const ApiDoc = ({ spec }: PropsType) => <div>{spec}</div>;
const ApiDoc = () => <div />;

export const getServerSideProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) =>
  // const spec = JSON.parse(fs.readFileSync('openapi/swagger.json', 'utf8'));

  ({
    props: {
      simpleLayout: true,
      attachFirstChildToNavigation: false,
      ...(await getLayoutData(locale as TLocale)),
      ...(await serverSideTranslations(locale as string)),
      spec: {},
    },
  });

export default ApiDoc;
